export default __webpack_public_path__ + "static/media/0408E4EE-A192-4C2C-950B-D52E3443B764_1_105_c.8349086d.jpeg";